import React, { useCallback } from 'react';
import { Dialog, Flex, Text, IconButton, Icon, Link } from '@scale/scaleui-radix';
import { faClose, faExternalLink } from '@fortawesome/pro-regular-svg-icons';
import { useHistory } from 'react-router-dom';
interface CreateSessionSuccessModalProps {
  // TODO: Add shared typing for endpoint response in useCreateWebinarSession
  newlyCreatedSessions: any[]; // Since this modal is shared between the old and new implementations, we need to use a prop instead of the store
  showModal: boolean;
  toggleModal: () => void;
}

export const CreateSessionSuccessModal: React.FC<CreateSessionSuccessModalProps> = ({
  newlyCreatedSessions,
  showModal,
  toggleModal,
}) => {
  const history = useHistory();
  const handleClose = useCallback(() => {
    toggleModal();
    if (newlyCreatedSessions.length > 0) {
      history.push(`./${newlyCreatedSessions[0].sessionCollection}`);
    }
  }, [toggleModal, newlyCreatedSessions, history]);

  return (
    <Dialog.Root open={showModal} onOpenChange={handleClose}>
      <Dialog.Content size="1" width="500px">
        <Flex justify="between">
          <Text size="4">
            You have successfully created {newlyCreatedSessions.length} session(s).
          </Text>

          <Dialog.Close>
            <IconButton variant="ghost" color="neutral">
              <Icon label="Close" icon={faClose} size="2" />
            </IconButton>
          </Dialog.Close>
        </Flex>

        <Flex direction="column" gap="4" mt="4" width="100%">
          <Text>
            If you want to pay for this webinar, please follow this mission config link to prefill a
            mission for this webinar.
          </Text>
          <Text>
            The mission will start at the same time as the webinar, and will{' '}
            <strong>end 2 hours after the webinar ends</strong> to allow extra time for attendance
            collection.
          </Text>
          {!!newlyCreatedSessions.length && (
            <Link
              href={`/corp/mission-config/new?webinar=${newlyCreatedSessions[0].sessionCollection}`}
            >
              <Flex align="center" gap="1">
                <Text>Create pre-filled mission</Text>
                <Icon label="ExternalLink" icon={faExternalLink} size="2" />
              </Flex>
            </Link>
          )}
        </Flex>
      </Dialog.Content>
    </Dialog.Root>
  );
};
